import { Injectable } from '@angular/core';
import {ITrackGA4NativeService, ParamDefaultGA4 } from './itrack-ga4-native';

declare const trackGA4;

declare global {
    interface Window {
        webkit: any;
    }
}

@Injectable({ providedIn: 'root' })
export class TrackGA4NativeService implements ITrackGA4NativeService {


    trackGA4(paramDefautl: ParamDefaultGA4, paramComplementary?: Record<string, string>) {
        const data = {
            ...paramDefautl,
            ...paramComplementary
        };

        /* Send mensage for IOS or Android */
        if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.trackGA4) {
            this.trackGA4Ios(data);
        } else {
            this.trackGA4Android(data);
        }
    }

    private trackGA4Ios(data: Record<string, string>) {
        window.webkit.messageHandlers.trackGA4.postMessage(data);
    }

    private trackGA4Android(data: Record<string, string>) {
        try {
            trackGA4.postMessage(JSON.stringify({...data}));
        } catch (error) {
        }
    }
}

